import { CustomAppLayout } from '../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useRef, useState } from 'react';
import { useRouter } from '../../router';
//import { useStore } from '../store';
import { useGlobalState } from '../../../context/GlobalStateContext';
const _preserve = React.version;

import mqtt, { MqttClient } from 'mqtt';
//import { useStoreAdmin } from '../../../../context/useStoreAdmin';
import Avatar from '@cloudscape-design/chat-components/avatar';
import ChatBubble from '@cloudscape-design/chat-components/chat-bubble';
import { PromptInput, SpaceBetween, SplitPanel, Table } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiAlertCircleOutline, mdiFileSendOutline, mdiHeadDotsHorizontalOutline } from '@mdi/js';
import Icon from '@mdi/react';
import Favorites from '../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../hooks/fetchWithWatch';
import { buildBreadcrumbItems, getCookie, getUrlVersion } from '../../../commons/functions';

interface MqttPayload {
    idPrompt: number;
    fromUser: boolean;
    data: any;
    message: string;
    status: string;

}


interface MqttMessage {
    topic: string;
    payload: MqttPayload;
}

export const IADataQueryPage = () => {
    const { idUser, data, menu } = useGlobalState();
    useGlobalState();
    const { navigate } = useRouter();


    const workerRef = useRef<Worker | null>(null);
    const [client, setClient] = useState<MqttClient | null>(null);
    const [messages, setMessages] = useState<MqttPayload[]>([]);
    const [sqlData, setSqlData] = useState<any[]>([]);
    const [status, setStatus] = useState<string>('');
    const [prompt, setPrompt] = useState<string>('');
    const [isDisconnected, setIsDisconnected] = useState(false);
    const [isWorking, setIsWorking] = useState(false);
    const [panel, setPanel] = useState(true);
    let cnx = -1;
    const clientRef = useRef<MqttClient | null>(null);
    const topicQuery = `CPV/IA/QUERY/${idUser}`;

    const connectMqtt = () => {

        console.log("Starting connection sequence...");
        if (!workerRef.current) {
            workerRef.current = new Worker(new URL('./heartbeat.worker.ts', import.meta.url));
        }

        workerRef.current.onmessage = (e) => {
            if (e.data.action === 'tick' && mqttClient.connected) {
                //const heartbeatPayload = JSON.stringify({ idDisplay: currentDisplay });
            }
        };
        // 1. Safe Cleanup
        try {
            if (clientRef.current) {
                console.log("Existing client found, forcing termination...");
                clientRef.current.end(true); // 'true' is critical here
                clientRef.current = null;
            }
        } catch (e) {
            console.error("Error during cleanup:", e);
        }


        // Use the ref to check for existing connection to prevent duplicates
        //if (clientRef.current && clientRef.current.connected) return;

        const clientId = `CLIENT.${idUser}`; //.${Math.random().toString(16).substr(2, 8)}

        const mqttClient = mqtt.connect("wss://mqtt.llavemovil.com:8081/", {
            keepalive: 30,
            clean: true,
            reschedulePings: true,
            reconnectPeriod: 5000,
            connectTimeout: 15 * 1000,
            clientId: clientId,
            username: 'cpv_client',
            password: 'cpv_client',
        });

        // Assign to Ref immediately

        mqttClient.on('connect', () => {
            setIsDisconnected(false);
            workerRef.current?.postMessage({ action: 'start', interval: 15000 });
            console.log("Connected to MQTT broker with clientId:", clientId);
            const topic = `CPV/IA/REPLIES/${idUser}`;
            mqttClient.subscribe(topic);
            console.log("Subscribed to topic:", topic);

            //mqttClient.subscribe(`FIDS/DISPLAY/${currentDisplay}`);
            mqttClient.publish(topicQuery, JSON.stringify({ idUser: 7003 }), { retain: true });
            console.log("Queries are sent to topic:", topicQuery, "with payload:", JSON.stringify({ idUser: 7003 }));
            //mqttClient.publish(`FIDS/UPDATE/DISPLAY  JSON.stringify({ idAirport: currentAirport }), { retain: true });
        });

        // --- PERIODIC MESSAGE START ---
        const heartbeatInterval = setInterval(() => {
            if (mqttClient.connected) {
                const heartbeatPayload = JSON.stringify({
                    idUser: idUser
                });
                mqttClient.publish(`CPV/IA/USERS/PING`, heartbeatPayload);
            }
        }, 15000); // 15 seconds

        mqttClient.on('error', (err) => {
            console.error('Connection error: ', err);
            setIsDisconnected(true);
            mqttClient.end();
        });
        mqttClient.on('close', () => {
            console.warn("MQTT Connection closed. Reconnect will be attempted...");
            setIsDisconnected(true);
            // Stop the worker timer when the connection drops
            workerRef.current?.postMessage({ action: 'stop' });
            //setStatus('Reconnecting...');
        });
        mqttClient.on('reconnect', () => {
            console.log("MQTT attempting to reconnect...");
            setIsDisconnected(true);
            setStatus('connecting');
        });

        mqttClient.on('offline', () => {
            console.error("MQTT is offline.");
            setIsDisconnected(true);
            setStatus('offline');
        });
        mqttClient.on('disconnect', () => {
            setStatus('disconnect');
            setIsDisconnected(true);
            console.log('Disconnected from MQTT broker');
        });

        mqttClient.on('message', (topic: string, message: Buffer) => {
            setIsDisconnected(false);
            const msg = JSON.parse(message.toString());
            setMessages(prevMessages => [...prevMessages, msg]);
            //console.log(!msgTest.fromUser ? "IA: " : "User: ");
            console.log(msg.status);
            if (msg.data && Array.isArray(msg.data) && msg.data.length > 0) {
                setSqlData(msg.data);
                setPanel(false);
            }
            if (msg.status) {
                if (msg.status == "finalizado")
                    setStatus("");
                else
                    setStatus(msg.status);
            }
            try {
                //const msgTest = JSON.parse(message.toString());
            } catch (err) {
                console.error("Error handling MQTT message:", err);
                return;
            }
            console.log("MQTT Message received on topic:", topic, " with payload:", JSON.parse(message.toString()));
        })
        setClient(mqttClient);
        clientRef.current = mqttClient;
    };
    useEffect(() => {
        connectMqtt();
        // Cleanup on component unmount
        return () => {
            if (clientRef.current) {
                clientRef.current.end();
            }
        };
    }, [idUser]);
    useEffect(() => {
        if (messages.length > 0) {
            console.log(messages);
        }
    }, [messages]);
    const handSendPrompt = async () => {
        try {
            setStatus("enviando");
            setIsWorking(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/user/ia/dbquery',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({
                    message: prompt,
                    fromUser: true,
                    idPrompt: 0,
                    data: null,
                    status: "pending"
                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();

            if (data.code == 0) {
                setPrompt("");
            }
        } catch (error: any) {

        } finally { setIsWorking(false); }
    }

    const getDynamicColumnDefinitions = (dataArray: any) => {
        if (!dataArray || dataArray.length === 0) {
            return [];
        }

        // Extract keys from the first object in the dataset
        const firstItem = dataArray[0];

        return Object.keys(firstItem).map((key) => {
            // Optional: Format the key to a readable header string (e.g., "idFlight" -> "Id Flight")
            const header = key
                .replace(/([A-Z])/g, ' $1')
                .replace(/^./, (str) => str.toUpperCase());

            return {
                id: key,
                header: header,
                cell: (item: any) => item[key] !== null && item[key] !== undefined ? String(item[key]) : '-',
                sortingField: key, // Enables built-in sorting for Cloudscape tables
            };
        });
    };
    const statusLabel = (() => {
        if (status === "enviando") {
            return <Icon path={mdiFileSendOutline} size={1} spin />;
        } else if (status === "pensando") {
            return <Icon path={mdiHeadDotsHorizontalOutline} size={1} spin />;
        } else if (status === "error") {
            return <Icon path={mdiAlertCircleOutline} size={1} color='red' />;
        } else {
            return null;
        }
    })();
    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }

            splitPanelPreferences={{
                position: "side",
            }}

            splitPanelOpen={panel}
            onSplitPanelToggle={() => setPanel(!panel)}

            splitPanelSize={600}
            content={
                <SpaceBetween size="s">
                    <Header variant="h1" actions={<Favorites />}>Template</Header>
                    {sqlData.length > 0 && (
                        <Table columnDefinitions={getDynamicColumnDefinitions(sqlData)}
                            items={sqlData}
                        />
                    )}


                </SpaceBetween>
            }
            splitPanel={
                <SplitPanel headerInfo="IA Data Query" hidePreferencesButton>
                    <SpaceBetween size="s" direction="vertical">

                        {messages.map((msg, index) =>
                            !msg.fromUser ? msg.status === "error" ? (
                                <ChatBubble
                                    ariaLabel="Generative AI assistant at 6:35:10pm"
                                    type="incoming"

                                    avatar={
                                        <Avatar
                                            color="default"
                                            initials='IA'
                                            iconName="status-warning"
                                            ariaLabel="Generative AI assistant"
                                            tooltipText="Generative AI assistant"
                                        />
                                    }
                                >{msg.message}</ChatBubble>
                            )
                                : (
                                    <ChatBubble
                                        ariaLabel="Generative AI assistant at 6:35:10pm"
                                        type="incoming"

                                        avatar={
                                            <Avatar
                                                color="gen-ai"
                                                initials='IA'
                                                ariaLabel="Generative AI assistant"
                                                tooltipText="Generative AI assistant"
                                            />
                                        }
                                    >{msg.message}</ChatBubble>
                                )
                                : (
                                    <ChatBubble
                                        ariaLabel="User at 6:35:10pm"
                                        type="outgoing"
                                        avatar={
                                            <Avatar
                                                color="default"
                                                iconName="user-profile"
                                                ariaLabel="User"
                                                tooltipText="User"
                                            />
                                        }
                                    >{msg.message}</ChatBubble>
                                ))}


                        {statusLabel}

                        <PromptInput
                            onChange={({ detail }) => setPrompt(detail.value)}
                            value={prompt}
                            ariaLabel="Default prompt input"
                            placeholder="Ask a question"
                            actionButtonIconName="send"
                            onAction={(e) => {
                                if (e.detail.value.trim() !== "") {
                                    handSendPrompt();
                                }
                            }}
                            disabled={isDisconnected || isWorking}
                        />
                    </SpaceBetween>
                </SplitPanel>
            }
        />
    )
};
